var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slice',[_c('b-container',{staticClass:"slice-people"},[_c('header',[_c('h1',{staticClass:"main-headline display"},[_vm._v(" "+_vm._s(_vm.slice.primary.headline)+" ")])]),_c('section',{staticClass:"items"},_vm._l((_vm.slice.items),function(person){return _c('Person',{key:person.id,staticClass:"item",attrs:{"uid":person.person.uid}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }